
import styled from "styled-components";
import background from '../../assets/images/bg.png';

export const StyledForgotPassword = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    background-image: url(${background});
    background-position: center;
    background-size: cover;
`;